import { type FunctionComponent } from "react";
import type { ReferenceMapValue } from "@noa/api-client";
import { LinkDocInfo } from "./link-doc-info";
import { useTranslation } from "react-i18next";

interface ChatMessageReferenceProps {
  refNumber: number;
  refIds: string[];
  referenceMap: Map<string, ReferenceMapValue>;
}

export const ChatMessageReference: FunctionComponent<ChatMessageReferenceProps> = ({
  refNumber,
  refIds,
  referenceMap,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginBottom: "4px" }}>
      <p style={{ fontStyle: "italic", marginBottom: "0" }}>{t("chat:reference.referenceNumber", { refNumber })}</p>
      {refIds.map((refId) => {
        const refData = referenceMap.get(refId);
        if (!refData?.used_sources) return null;

        const { used_sources } = refData;

        return <LinkDocInfo key={refId} refNumber={refNumber} used_sources={used_sources} />;
      })}
    </div>
  );
};
